import { createSelector } from '@ngrx/store';
import { getHistoryOrderTypeGroup } from '../getHistoryOrderTypeGroup';

export const isHistoryOrderDineIn = (orderGUID: string) => createSelector(getHistoryOrderTypeGroup(orderGUID), (type) => type === OLO.Enums.COLLECTION_TYPE.DINE_IN);
